import React from 'react'
import styles from './styles.module.css'
import Image from 'src/comps/Image'
import { useIntl } from 'react-intl'
import { LoadingSpinner } from './LoadingSpinner'
import { PATH_IMAGES_CDN } from 'src/constants/environment'
import { Text } from 'src/comps/Atom/Text'
import Shield from 'client/icons/Shield'

const LoadingPayment = () => {
  const intl = useIntl()

  return (
    <section className={styles.loader}>
      <div className={styles.message}>
        <LoadingSpinner />
        <div>
          <Text variant="captionL" weight="weight2">
            {intl.formatMessage({ id: 'global.process-payment-wait' })}
          </Text>
          <Text variant="captionL" weight="weight2">
            {intl.formatMessage({ id: 'redirect.copy-60s' })}
          </Text>
        </div>
      </div>
      <div className={styles.preloader}>
        <Image
          alt="An illustration of a person planting a flag"
          src={`${PATH_IMAGES_CDN}/250401_illustration-flag.png`}
          className={styles.preloaderImage}
        />
        <div className={styles.secureConnection}>
          <Shield width={24} height={24} fill="var(--color--semantic--success--500)" />
          <Text variant="textBodyL" weight="weight4">
            {intl.formatMessage({ id: 'global.secure-connection' })}
          </Text>
        </div>
      </div>
    </section>
  )
}

export default LoadingPayment
